module.exports = {
      id: "environment-usage",
      viewBox: "0 0 28.781 28.787",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#environment",
      toString: function () {
        return this.url;
      }
    }